import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";
import { useLanguage } from "../../context/LanguageContext";

function AboutCard() {
  const { t } = useLanguage();
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            <img
              src={`${process.env.PUBLIC_URL}/logo/big-logo.png`}
              alt={t("seo.siteName")}
              className="broxe-about-inline-logo"
            />{" "}
            {t("aboutCard.p1rest")}
            <br />
            <br />
            {t("aboutCard.p2")}
          </p>

          <ul>
            <li className="about-activity">
              <ImPointRight /> {t("aboutCard.li1")}
            </li>
            <li className="about-activity">
              <ImPointRight /> {t("aboutCard.li2")}
            </li>
            <li className="about-activity">
              <ImPointRight /> {t("aboutCard.li3")}
            </li>
          </ul>

          <p style={{ color: "rgb(148 163 184)" }}>{t("aboutCard.quote")}</p>
          <footer className="blockquote-footer">
            <img
              src={`${process.env.PUBLIC_URL}/logo/big-logo.png`}
              alt={t("seo.siteName")}
              className="broxe-about-footer-logo"
            />
          </footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
